import React,{ useState , useEffect} from 'react';
import { CusFormLabelFours, CusFormLabelRtl, FormSubTitle, FormSubTitleDesp } from '../validation/Form-Components';
import FormContainer from '../components/FormContainer';
import { Form, Field, FormElement, FieldWrapper } from '@progress/kendo-react-form';
import previewData from '../data/previewdata.json';
import CusFormTitle from '../components/CusFormTitle';
import config  from '../appconfig/config.json';
import { useHistory } from "react-router-dom";
import service from '../services/ApiService.js';
import countries from '../data/countries.json';
import myInfoCountries from '../data/myInfoCountryList.json';
import Loading from '../components/Loading';
import branchList from '../data/branch.json'
import sgdaccount from '../data/sgdaccount.json'
import frngaccount from '../data/foreignaccount.json'
import sign from '../data/condofsign.json'
import accOpeningData from '../data/accopeningdata.json';
import txnActData from '../data/txnactivitiesdata.json';
import occupationList from '../data/occupations.json';
import bizBankingData from '../data/bizbankingservicedata.json'
import ServiceLinkage from '../components/ServiceLinkage';
import serviceLinkages from '../data/serviceslinkage.json';
import taxDetailsData  from '../data/taxdetailsdata.json';
import fatcaList from '../data/fatcalist.json';
import { Input } from "@progress/kendo-react-inputs";
import AccountLinkage from '../components/AccountLinkage';
import mandates from '../data/mandate.json'; 
import delegateData from '../data/delegationdetailsdata.json';
import ApplicantDtlsPreview from '../components/ApplicantDtlsPreview';
import storage from '../factory/StorageFactory';
import uploadConfig from '../data/uploaddetailsdata.json';
import useCountDown from "react-countdown-hook";
import optService from '../services/OtpApiService';
import CusToast from '../components/CusToast';
import helper from '../factory/Helper';
import appDetailsData from '../data/applicantdetailsdata.json';

let prpsAcctOpenStr = '', wealthCntyStr = '', bizActListStr = ''; //Account Opening checkboxes
let bizIncStr= '',bizPayStr = '', paymentModeStr = '', currenciesStr = '',antTranMoStr = '', antSGDTranStr = '', majorBuyersStr = '';  //Txn Details
let descActOccListStr = ''; 
let acctLinkListArray = [], serviceLinkageArray = [], bizCardApplicantsArray=[], userRegistrationArray=[] ;
let applicantTIN1 = {}, applicantTIN2 = {};
let deleDtlsAuthSignStr= '',benificialOwnerStr ='' ,apptAuthPersonStr = '',certifyPersonStr='';
let docSignatureArray = [], docMemorandumArray = [], docLLPArray=[], docACSArray=[];
let appDtls1 = {}, appDtls2 = {}, appDtls3 ={}, appDtls0 ={};
let hasMyInfo1 = false, hasMyInfo2= false, hasMyInfo3=false;
let holders = [];
let otpAuthToken = '';
let count3TimeToExist = 0;
let otpMobileNo= '';
let count3TimeExpired = 0;
let branches = branchList;

const Preview = (props) => {
 
    const enableOTP = config.EnableOTP;
    const seq0='0', seq1='1',seq2='2',seq3='3';

    let timer;

    const initialTime = 120 * 1000; // initial time in milliseconds, defaults to 60000
    const interval = 1000; // interval to change remaining time amount, defaults to 1000
    const [timeLeft, { start, pause, resume, reset }] = useCountDown( initialTime, interval );
 
    const [OTPValue, setOTPValue] = useState("");
    const [OtpconfirmDisabled, setOtpconfirmDisabled] = useState(false);
    const [showOTPBar, setShowOTPBar] = useState(false);
    const [isOtpLoading,setIsOtpLoading] = useState(false);
    const [isOtpGeneratedSuccess,setIsOtpGeneratedSuccess] = useState(false);
  
    const docTypeSignature ='Signature', docTypeMemorandum= 'Memorandum', docTypeLLP ='LLP', docTypeACS = 'MinutesOfMeeting';
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(true);  //to show api call
 
    const [isError,setIsError] = useState(false);
    const [errMsg, setErrMsg] = useState('');

    const [currentTime, setCurrentTime] = useState();

    const [showOTPResendRequestErr, setShowOTPResendRequestErr] = useState(false);
    
    const initialResState = {
        // CompanyDetails Form
        CompDtls:{
            IssuedCapitalAmount:"",
            RegNo: "",
            CompName: "",
            CompType: "",
            DtOfInc: "",
            CompTypeCode:"",
            CountryOfInc: "",
            SoleorNonSole:"",
            FormerName:""
        },
        RegBizAddr:{
            AddType:"",
            BlkNo: "",
            Street: "",
            FlrNum: "",
            UnitNo: "",
            BldName: "",
            PostalCode: "",
            AddLine1:"",
            AddLine2:"",
            Country:""
        },
        RegBizMailAddr: {
            SameAsRegBizAddr: null,
            AddType: "",
            BlkNo: "",
            Street: "",
            FlrNum: "",
            UnitNo: "",
            BldName: "",
            PostalCode: "",
            Country: "",
            CompTypeCode:"",
            CompType:""
        },
        // End CompanyDetails Form

        // Account Opening
        BizAccts: {},
        PrpsAcctOpen: {},
        WealthOutSG: "",
        WealthCnty: {},
        PrimaryBizAct: "",
        SecondaryBizAct: "",
        BizActList:{},
        // End Account Opening

        // Transaction Details
        BizInc: {},
        BizPay:{},
        PaymentMode:{},
        Currencies:{},
        AntTranMo: '',
        AntTranMonOth:'',
        AntSGDTran:'',
        AntSGDTranOth: '',
        MajorBuyers:{},
        MajorSuppliers:{},
        // End Transaction Details

         // Applicant Details
        ApplicantDtls:[],
        // End Applicant Details
          
        //Business Banking Details
      
        MaybankBussinessPlatinumCard:{},
        BizInternetBank:{},
        // End Business Banking Details

        //Delegation Details
        SignConditionAP:'', 
        ASBOConOfSign:'',
        ApptAuthPerson:[],
        AuthSign:[],
        BenificialOwner:[],
        IsAboveABeneficialOwner:'',
        // End Delegation Details

        //Tax Details
        TaxStatus:{},
        CRSFATCA:{
            IsActiveBizEntity: '',
            CRSStatus: '',
            FATCAUS: '',
            FATCABIZ: '',
            FATCAUSC: '',
            FATCAUSPR: '',
            FATCAUSR: '',
            FATCANUSP: ''
        },
        DocSubmit:{
            AdoptAcraTemplate:'',
            Doc:''
        },
        TaxClare:''
    };

    const [response, setResponse] = useState(initialResState);

   

    useEffect(() => {
        
        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }

        if(helper.isInvalidState()) {
            window.location.href = config.link.Cancle;
            return;
        }
        
        window.scrollTo(0,0);
        varDeclaration();
        // getData(); 
        getFormData();

        return () => clearTimeout(timer);
     }, []);

    const varDeclaration = () => {
        prpsAcctOpenStr = ''; wealthCntyStr = ''; bizActListStr = ''; //Account Opening checkboxes
        bizIncStr= ''; bizPayStr = ''; paymentModeStr = ''; currenciesStr = ''; antTranMoStr = ''; antSGDTranStr = ''; majorBuyersStr = '';  //Txn Details
        descActOccListStr = ''; 
        acctLinkListArray = []; serviceLinkageArray = []; bizCardApplicantsArray=[];userRegistrationArray=[];
        applicantTIN1 = {}; applicantTIN2 = {};
        deleDtlsAuthSignStr='';benificialOwnerStr=''; apptAuthPersonStr=''; certifyPersonStr='';
        docSignatureArray=[]; docMemorandumArray = []; docLLPArray=[]; docACSArray = [];
        appDtls1 = {}; appDtls2 = {}; appDtls3 ={};appDtls0={};
        holders=[];
        hasMyInfo1 = false; hasMyInfo2= false; hasMyInfo3=false;
        otpAuthToken= '';
        count3TimeToExist= 0;
        count3TimeExpired = 0;
        otpMobileNo='';
        getTodayDate();
        getCurrentTime();
    }
     
    const handleSubmit = (e) => {
        e.preventDefault();
      
        if(OTPValue.length === 6) {
            if(enableOTP){
               
                if(timeLeft === 0) {  //check generated OTP expired time
                    count3TimeExpired = count3TimeExpired+1;
                    setOTPValue('');
                    showErrMsg('The OTP entered has expired. Please re-enter the 6 Digit OTP.')
                    return;
                }

                count3TimeToExist = count3TimeToExist + 1;
               verifyOTPDetails();
            }
            else {
                submitWithFields(false);
            }
        }
    }

    const handleResendOTP = (e) => {
        e.preventDefault();
        if(timeLeft === 0) {
            setShowOTPResendRequestErr(false);
            const newTime = 120 * 1000;
            start(newTime);
            generateOTP(otpAuthToken,otpMobileNo);
        }
        else {
            setShowOTPResendRequestErr(true);
        }
    }

    const disableSubmitOTPBtn = () => {
        let disableBtn = false;
        if(!OTPValue){
            disableBtn = true;
        }
        else if(OTPValue.length !== 6) {
            disableBtn = true;
        }

        return disableBtn;
    }

    const handleShowOTP = (e) => {
        e.preventDefault();
        setShowOTPBar(true);
    }

    const handleRequestOTP = (e) => {
        e.preventDefault();
       
        if(enableOTP) {
            otpMobileNo = getCurrentUserMobileNo();
            generateOTP(otpAuthToken,otpMobileNo);
        }
    }

    const handleSaveContinue = (e) => {
        console.log('@handleSaveContinue')
        e.preventDefault();
        submitWithFields(true);
    }

    const getCurrentUserMobileNo = () => {
        const order = getLoginUserOrder(response);
        let mno = '';
        if(order === seq0) {
            mno = appDtls0.MobileNo;
        }
        else if(order === seq1) {
            
            mno = appDtls1.MobileNo;
        }
        else if(order === seq2) {
            mno = appDtls2.MobileNo;
        }
        else if(order === seq3) {
            mno = appDtls3.MobileNo;
        }
        else { // Sole
            mno = appDtls1.MobileNo;
        }

        return mno;
    }
 
    const submitWithFields = (isContinue) => {
        setIsOtpLoading(true);
        let params = {};
        if(!isSoleProps()){ // non sole
            params = {
                CurrentUser: {
                    IDNum:response.ApplicantsDtlsMyInfo.IDNum,
                    Seq:getLoginUserSeq(),
                    Order: getLoginUserOrder(response),
                    isContinue:isContinue
                }
            }
        }
        else {
            params = {
                CurrentUser: {
                    IDNum:response.ApplicantsDtlsMyInfo.IDNum,
                    Seq:null,
                    Order: null,
                    isContinue:isContinue
                }
            }
        }
        
        service.post('',params).then(res => {
            setIsOtpLoading(false);
            let resData = res.data;
            if(resData.isSucess) {
                goNext(isContinue,resData.model.date);
            }
            else {
                showErrMsg(config.error.SaveApiFailed);
            }          
        })
        .catch(err => {
            setIsOtpLoading(false);
            showErrMsg(config.error.SaveApiFailed);
        });
      
    }

    const goNext =(isContinue,expiredDate) => {
        if(isContinue) {
            history.push(config.route.SubmitSaveAndContinue,{from: config.route.Preview,expDate:expiredDate});
        }
        else {
            if(isSoleProps()) {
                history.push(config.route.Submit);
            }
            else {
                history.push(config.route.NSSubmit,{from: config.route.Preview, responseData: response});
            }
        }
    }
    
    const getLoginUserOrder = (resObj) => {
        let authSeq = '', isAuthPerson = false;
        if(!Array.isArray(resObj.ApplicantDtls)){ //check obj or array
            if(resObj.ApplicantDtls.IDNum ===  resObj.ApplicantsDtlsMyInfo.IDNum){
                authSeq = resObj.ApplicantDtls.ApplicantSeq;
                isAuthPerson = true;
            }
            else {  //non login user
                authSeq = '0';
                isAuthPerson = false;
            }
        }
        else { //array
            for(let i in resObj.ApplicantDtls) {
                if(resObj.ApplicantDtls[i].IDNum ===  resObj.ApplicantsDtlsMyInfo.IDNum) {  // get login user's seq number 
                    authSeq = resObj.ApplicantDtls[i].ApplicantSeq;
                    isAuthPerson = true;
                }
            }
        }
        if(isAuthPerson){
            return authSeq;
        }
        else {
            return '0';
        }
    }

    const getLoginUserSeq = () => {
        if(response.ApplicantsDtlsMyInfo.isFirstUser === 'true') {  // first user
            return 0;
        }
        else {  // not first user
            if(!Array.isArray(response.ApplicantDtls)) { //check obj
                if(response.ApplicantDtls.IDNum ===  response.ApplicantsDtlsMyInfo.IDNum){
                    return response.ApplicantDtls.ApplicantSeq;
                }
            }
            else { //array
                for(let i in response.ApplicantDtls){
                    if(response.ApplicantDtls[i].IDNum ===  response.ApplicantsDtlsMyInfo.IDNum){
                        return response.ApplicantDtls[i].ApplicantSeq;
                    }
                }
            }
        }
    }

    const getData = () => {
        let url = helper.getBaseApiUrl();
        service.getBranches(url+'/rsme').then( res => {
            branches = res.data;
            getFormData();
        })
        .catch(err => {
           
            getFormData();
        })
    }

    const getFormData = () => {
        service.get().then( res => {
            if(res.data.isSucess) {
                createHolders(res.data.model.fields.request);
                setResponse(res.data.model.fields.request);
                storage.setRefNo(res.data.model.fields.request.RefNum);
                setBizCardApplicantsArray(res.data.model.fields.request.MaybankBussinessPlatinumCard);
                setUserRegistrationArray(res.data.model.fields.request.BizInternetBank.UserRegistration);
                setDeleDtlsAuthSign(res.data.model.fields.request);
                setBenificialOwner(res.data.model.fields.request);
                setApptAuthPerson(res.data.model.fields.request);
                setCerifyPerson(res.data.model.fields.request.BoardResolutions);
                setDocArray(res.data.model.fields.request.DocSubmit);
                setSignArray(res.data.model.fields.request);
                setApplicantDtlsObj(res.data.model.fields.request);

                if(enableOTP) {
                    getOTPSecurityToken();  
                }
                
                setIsLoading(false);
            }
            else {
                setIsLoading(false);
                showErrMsg(config.error.GetApiFailed);
            }
        })
        .catch(err => {
            console.log('@Preview getData ',err);
            setIsLoading(false);
            showErrMsg(config.error.GetApiFailed);
        })
    }

    const bindData =()=> {
      displayChkValueInString();
    }

    const showErrMsg = (msg) => {
        setIsError(true);
        setErrMsgTimeout();
        if(msg !== null) {
            setErrMsg(msg);
        }
        else {
            setErrMsg(config.error.GetApiFailed);
        }
    }

    const setErrMsgTimeout= () => {
        timer = setTimeout(() => {
            setIsError(false);
            if(count3TimeToExist === 3 || count3TimeExpired === 3) {
               // console.log('Invalid OTP Page')
                gotoInvalidOTP();
                return;
            }
        }, config.error.msgTimeout);
    }

    const displayChkValueInString = () => {
        setApplicantTinObj();
        setPrpsAcctOpenStr();
        setWealthCnty();
        setBizActList();
        setBizInc();
        setBizPay();
        setPaymentMode();
        setCurrencies();
        setMajorBuyers();
        setAntTranMo();
        setAntSGDTran();
        setDescActOccList();
        setAcctLinkList();
        setServiceLinkList();
    }

    const setApplicantDtlsObj = (resData) => {
        let data = resData.ApplicantDtls;
        try{
            if(!Array.isArray(data)) {
                appDtls1 = data;
                setHasMyInfo1Value(appDtls1,resData);
            }
            else {
               for(let i in data) {
                
                   if(data[i].ApplicantSeq === '1') {
                       appDtls1 = data[i];
                       setHasMyInfo1Value(appDtls1,resData);
                   }
                   if(data[i].ApplicantSeq === '2') {
                        appDtls2 = data[i];
                        setHasMyInfo2Value(appDtls2,resData);
                   }
                   if(data[i].ApplicantSeq === '3') {
                        appDtls3 = data[i];
                        setHasMyInfo3Value(appDtls3,resData);
                    }
                    if(data[i].ApplicantSeq === '0') {
                       appDtls0 = data[i];
                    }
               }
            }
        }catch(ex){
           console.log('setApplicantDtlsObj: ',ex);
        }
    }

    const setHasMyInfo1Value = (data,resData) => {
        if(data.IDNum === resData.ApplicantsDtlsMyInfo.IDNum){
            hasMyInfo1 = true;
        }
        else if(resData.SubmittedApplicants.Applicant1 === 'true') {
            hasMyInfo1 = true;
        }
        else {
            hasMyInfo1 = false;
        }
    }

    const setHasMyInfo2Value = (data,resData) => {
        if(data.IDNum === resData.ApplicantsDtlsMyInfo.IDNum){
            hasMyInfo2 = true;
        }
        else if(resData.SubmittedApplicants.Applicant2 === 'true') {
            hasMyInfo2 = true;
        }
        else {
            hasMyInfo2 = false;
        }
    }

    const setHasMyInfo3Value = (data,resData) => {
        if(data.IDNum === resData.ApplicantsDtlsMyInfo.IDNum){
            hasMyInfo3 = true;
        }
        else if(resData.SubmittedApplicants.Applicant3 === 'true') {
            hasMyInfo3 = true;
        }
        else {
            hasMyInfo3 = false;
        }
    }

    const isFirstUser = (authPerson,loginPerson) => {
 
        if(loginPerson.isFirstUser === 'true') {
            return true;
        }
        else if(authPerson.IDNum === loginPerson.IDNum) {
            return true;
        }
        else {
            return false;
        }
    }

    const showEditTitle = () => {
        if(response.ApplicantsDtlsMyInfo !== undefined) {
            if(response.ApplicantsDtlsMyInfo.isFirstUser === 'false') {
                return false;
            }
            else {
                return true;
            }
        }
      
        return false;
    }

    const showUploadDtlsEdit = () => {
        if(response.ApplicantsDtlsMyInfo.isFirstUser === 'true') {  //first AP
            return true;
        }
        else { // non first AP
            if(Array.isArray(response.ApplicantDtls)) {
                for(let i in response.ApplicantDtls) {
                    if(response.ApplicantsDtlsMyInfo.IDNum === response.ApplicantDtls[i].IDNum) { //login user
                        if(response.ApplicantDtls[i].Authorised === 'false') {
                            return false;
                        }
                        else {
                            return true;
                        }
                    }
                }
            }
            else {
                return true;
            }
        }
    }

    const setApplicantTinObj = () => {
 
       try{
        if(response.TaxStatus.ApplicantTIN){
            if(!Array.isArray(response.TaxStatus.ApplicantTIN)) {
                applicantTIN1 = response.TaxStatus.ApplicantTIN;
            }
            else if(response.TaxStatus.ApplicantTIN.length === 1){
               
                applicantTIN1 = response.TaxStatus.ApplicantTIN[0];
            }
            else if(response.TaxStatus.ApplicantTIN.length === 2){
           
                applicantTIN1 = response.TaxStatus.ApplicantTIN[0];
                applicantTIN2 = response.TaxStatus.ApplicantTIN[1];
            }
        }
       
       }catch(ex) {
            console.log('setApplicantTinObj: ',ex);
       }
    }

    const setPrpsAcctOpenStr = () => {
        try{
            let labelArray = [];
            if(response.PrpsAcctOpen && response.PrpsAcctOpen !==null ) {
                getCheckedArray(response.PrpsAcctOpen).map( value => {
                    if(value.toUpperCase() === 'OTH') {
                        labelArray.push('Others('+response.PrpsAcctOpen.OthDesc+')');
                    }
                    else {
                        labelArray.push(getChkLabelInArray(value, accOpeningData.purposesChkbox.data))
                    }
                })
                prpsAcctOpenStr = labelArray.join(', ');
            }
        }
        catch(ex){
            console.log('setPrpsAcctOpenStr: ',ex);
        }
    }

    const setWealthCnty = () => {
        try{
            if(response.WealthOutSG === 'Y') {
                wealthCntyStr = '';
                return;
            }
    
            let labelArray = [];
            if(response.WealthCnty) {
                getCheckedArray(response.WealthCnty).map( value => {
                    if(value.toUpperCase() === 'OTH') {
                        labelArray.push('Others('+getLabelInArray(response.WealthCnty.Country,countries)+')');
                    }
                    else {
                        labelArray.push(getLabelInArray(value, countries))
                    }
                })
                wealthCntyStr = labelArray.join(', ');
            }
        }
        catch(ex){
            console.log('setWealthCnty: ',ex);
        }
    }

    const setBizActList = () => {
        try{
            let labelArray = [];
            if(response.BizActList) {
                getCheckedArray(response.BizActList).map( value => {
                    labelArray.push(getChkLabelInArray(value, accOpeningData.businessActivityChkbox.data))
                })
                bizActListStr = labelArray.join(', ');
            }
        }
        catch(ex){
            console.log('setBizActList: ',ex);
        }
     
    }

    const setBizInc = () => {
        let labelArray = [];

        getCheckedArray(response.BizInc).map( value => {
            if(value === 'BI8') {  // other transfer bank
                if(response.BizInc.BizIncActTrnBnk !== null){
                    labelArray.push('Transfer from other banks('+response.BizInc.BizIncActTrnBnk+')');
                }
            }
            else if(value === 'BI9') {
                if(response.BizInc.BizIncActOthDesc !== null){
                    labelArray.push('Others('+response.BizInc.BizIncActOthDesc+')');
                }
            }
            else if(value === 'BI1'){
                labelArray.push(txnActData.incomeChkbox.BI1.lblname);
            }
            else if (value === 'BI7') {
                labelArray.push(txnActData.incomeChkbox.BI7.lblname);
            }
            else {
                labelArray.push(getChkLabelInArray(value, txnActData.incomeChkbox.data))
            }
        })
        bizIncStr = labelArray.join(', ');
    }

    const setBizPay = () => {
        let labelArray = [];
        if(response.BizPay) {
            getCheckedArray(response.BizPay).map( value => {
               if(value === 'BP7') {
                    labelArray.push('Others('+response.BizPay.BizPayActOthDesc+')');
                }
                else if(value === 'BP6') {
                    labelArray.push(txnActData.paymentsChkBox.BP6.lblname); 
                }
                else {
                    labelArray.push(getChkLabelInArray(value, txnActData.paymentsChkBox.data))
                }
            })
            bizPayStr = labelArray.join(', ');
        
        }
    }
    
    const setPaymentMode = () => {
        let labelArray = [];
        if(response.PaymentMode) {
            getCheckedArray(response.PaymentMode).map( value => {
                labelArray.push(getChkLabelInArray(value, txnActData.txnModeChkBox.data))
            })
            paymentModeStr = labelArray.join(', ');
        }
    }

    const setCurrencies = () => {
        let labelArray = [];
        if(response.Currencies) {
            getCheckedArray(response.Currencies).map( value => {
               if(value.toUpperCase() === 'OTH') {
                    labelArray.push('Others('+response.Currencies.ApplCurrOthDesc+')');
                }
                else {
                    labelArray.push(getChkLabelInArray(value, txnActData.currenciesChkBox.data))
                }
            })
            currenciesStr = labelArray.join(', ');
        }
    }

    const setMajorBuyers = () => {
        let labelArray = [];
        if(response.MajorBuyers) {
            getCheckedArray(response.MajorBuyers).map( value => {
                if(value.toUpperCase() === 'OTH') {
                    labelArray.push('Others('+getLabelInArray(response.MajorBuyers.Country,countries)+')');
                }
                else {
                    labelArray.push(helper.getLabelInArray(value, countries))
                }
            })

            majorBuyersStr = labelArray.join(', ');
        }
    }

    const setAntTranMo = () => {
     
        if(response.AntTranMo === 'OTH') {
            antTranMoStr = 'Others('+response.AntTranMoValue+')';
        }
        else {
            antTranMoStr = response.AntTranMoValue;
        }
    }

    const setAntSGDTran = () => {
        if(response.AntSGDTran === 'OTH') {
            antSGDTranStr = 'Others('+response.AntSGDTranValue+')';
        }
        else {
            antSGDTranStr = response.AntSGDTranValue;
        }
    }

    const setDescActOccList = () => {
        try{
            let labelArray = [];
            if(response.ApplicantDtls.DescAccOccList) {
                getCheckedArray(response.ApplicantDtls.DescAccOccList.DescActOcc).map( value => {
                    labelArray.push(getChkLabelInArray(value,occupationList))
                })
                descActOccListStr = labelArray.join(', ');
            }
        }
        catch(ex){
            console.log('setDescActOccList: ',ex);
        }
    }

    const setBizCardApplicantsArray = (data) => {
 
        try{
            let labelArray = [];
            if(data.Applicant.length === undefined) { //object
                labelArray.push(data.Applicant);
            }
            else { //array
          
                labelArray = data.Applicant;
            }

            bizCardApplicantsArray = labelArray;
        }catch(ex) {
           console.log('setBizCardApplicantsArray: ',ex);
        }
    }



    const setUserRegistrationArray = (data) => {
        try{
            let labelArray = [];
            if(data){
                if(data.AuthUser.length === undefined){ //object
                    labelArray.push(data.AuthUser);
                }
                else { //array
                    labelArray = data.AuthUser;
                }
                
                userRegistrationArray = labelArray;
            }
        }
        catch(ex) {
            console.log('setUserRegistrationArray: ',ex);
        }
    }

    const setDeleDtlsAuthSign = (data) => {
        try{
            let labelArray = [];
            if(data.AuthSign){
                if(data.AuthSign.length === undefined){ //object
                    deleDtlsAuthSignStr = data.AuthSign.Name;
                }
                else { //array
                    for(let i in data.AuthSign) {
                        labelArray.push(data.AuthSign[i].Name);
                    }
                    deleDtlsAuthSignStr = labelArray.join(', ');
                }
            }
        }
        catch(ex) {
            
        }
    }

    const setBenificialOwner = (data) =>{
        try{
            let labelArray = [];
            if(data.BenificialOwner){
                if(data.BenificialOwner.length === undefined){ //object
                 
                    if(data.BenificialOwner.SelectedValue === 'true') {
                        benificialOwnerStr = data.BenificialOwner.Name;
                    }
         
                }
                else { //array
                    for(let i in data.BenificialOwner) {
                    
                        if(data.BenificialOwner[i].SelectedValue === 'true') {
                            labelArray.push(data.BenificialOwner[i].Name);
                        }
                        
                    }
                    benificialOwnerStr = labelArray.join(', ');
                }
            }
        }
        catch(ex) {
            console.log('setBenificialOwner: ',ex);
        }
    }

    const setApptAuthPerson = (data) =>{
        try{
            let labelArray = [];
            if(data.ApptAuthPerson){
                if(!Array.isArray(data.ApptAuthPerson)){ //object
                    apptAuthPersonStr = data.ApptAuthPerson.Name;
                }
                else { //array
                    for(let i in data.ApptAuthPerson) {
                        labelArray.push(data.ApptAuthPerson[i].Name);
                    }
                    apptAuthPersonStr = labelArray.join(', ');
                }
            }
        }
        catch(ex) {
            console.log('setApptAuthPerson: ',ex);
        }
    }

    const setCerifyPerson = (data) =>{
        try{
            let labelArray = [];
            if(data.CertifyPerson  || data.CertifyPerson !== null) {
                if(data.CertifyPerson.length === undefined){ //object
                    certifyPersonStr = data.CertifyPerson.Name;
                }
                else { //array
                    for(let i in data.CertifyPerson) {
                        labelArray.push(data.CertifyPerson[i].Name);
                    }
                    certifyPersonStr = labelArray.join(', ');
                }
            }
            else {
            }
        }
        catch(ex) {
            console.log('setCerifyPerson: ',ex);
        }
    }

    const setDocArray = (data) => {
 
        try{
            let memoArray=[], llpArray=[], acsArray=[];
         
            if(data.Doc) {
                if(!Array.isArray(data.Doc)){
                    if(data.Doc.DocType === docTypeMemorandum) {
                        memoArray.push(data.Doc)
                    }
                    else if(data.Doc.DocType === docTypeLLP){
                        llpArray.push(data.Doc);
                    }
                    else if(data.Doc.DocType === docTypeACS){
                        acsArray.push(data.Doc);
                    }
                }
                else {
                    for(let i in data.Doc) {
                        if(data.Doc[i].DocType === docTypeMemorandum) {
                            memoArray.push(data.Doc[i])
                        }
                        else if(data.Doc[i].DocType === docTypeLLP){
                            llpArray.push(data.Doc[i]);
                        }
                        else if(data.Doc[i].DocType === docTypeACS){
                            acsArray.push(data.Doc[i]);
                        }
                    }
                }
                
                docMemorandumArray = memoArray;
                docLLPArray = llpArray;
                docACSArray = acsArray;
            }
        }catch(ex){
            console.log('setDocArray: ',ex);  
        }
    }

    const setSignArray = (resData) => {
       
        try{
            let signTempArray = [],signArray = [];
            if(resData.DocSubmit.Doc) {
                if(!Array.isArray(resData.DocSubmit.Doc)){
                    if(resData.DocSubmit.Doc.DocType === docTypeSignature) {
                        signArray.push(resData.DocSubmit.Doc);
                    }
                }
                else {
                    for(let i in resData.DocSubmit.Doc) {
                        if(resData.DocSubmit.Doc[i].DocType === docTypeSignature) {
                            signTempArray.push(resData.DocSubmit.Doc[i]);
                        }
                       
                    }
                    for(let j in signTempArray) {
                        
                        const seq = getApplicantSeqByICbyResponse(signTempArray[j].NRIC,resData);
                 
                        if(signTempArray[j].NRIC === resData.ApplicantsDtlsMyInfo.IDNum){  //login user, must display
                            signArray.push(signTempArray[j])
                        }
                        else if(seq === seq0 && resData.SubmittedApplicants.Applicant0 === 'true') {
                            
                            signArray.push(signTempArray[j])
                        }
                        else if(seq === seq1 && resData.SubmittedApplicants.Applicant1 === 'true') {
                            
                            signArray.push(signTempArray[j])
                        }
                        else if(seq === seq2 && resData.SubmittedApplicants.Applicant2 === 'true') {
                            
                            signArray.push(signTempArray[j])
                        }
                        else if(seq === seq3 && resData.SubmittedApplicants.Applicant3 === 'true') {
                        
                            signArray.push(signTempArray[j])
                        }
                    }
                }

                docSignatureArray = signArray;
            }
        }catch(ex){
            console.log('@setSignArray',ex);
        }
    }

    const getApplicantSeqByICbyResponse = (idNum,resData) => {
        let applicantsTemp = [];
        
        if(Array.isArray(resData.ApplicantDtls)){ // array
            applicantsTemp = resData.ApplicantDtls;
        }
        else { // not array, object 
            applicantsTemp.push(resData.ApplicantDtls);
        }
        const obj = helper.getObjInArraybyIDNum(idNum,applicantsTemp);
        if(obj.ApplicantSeq) {
            return obj.ApplicantSeq;
        }
    }

    const getSignatureNameLabel = (signObj) => {
        const str1 = 'An image of your signature \n';
        const seq = getApplicantSeqByIC(signObj.NRIC);
        const name =str1+'(Authorised Person '+seq+' '+signObj.Name+')';
        return name;
    }

    const getApplicantSeqByIC = (idNum) => {
        let applicantsTemp = [];
        
        if(Array.isArray(response.ApplicantDtls)){ // array
            applicantsTemp = response.ApplicantDtls;
        }
        else { // not array, object 
            applicantsTemp.push(response.ApplicantDtls);
        }
        const obj = helper.getObjInArraybyIDNum(idNum,applicantsTemp);
        if(obj.ApplicantSeq) {
            return obj.ApplicantSeq;
        }
    }

    const setAcctLinkList = () => {
 
        try{
            let labelArray = [];
            if(response.BizInternetBank.AcctLinkList) {
                for(let i in response.BizInternetBank.AcctLinkList.AcctLinkage){
                    if(i === '0') {
                        labelArray.push(getLabelInArray(response.BizInternetBank.AcctLinkList.AcctLinkage[0],sgdaccount));
                    }
                    else if(i === '1'){
                        if(response.BizInternetBank.AcctLinkList.AcctLinkage[1] !== undefined || response.BizInternetBank.AcctLinkList.AcctLinkage[1] !== null){
                            labelArray.push(response.BizAccts.PrefFrngAcctDesc);
                        }
                    }
                    else {
                        labelArray.push(response.BizInternetBank.AcctLinkList.AcctLinkage[i]);
                    }
                }
                acctLinkListArray = labelArray;
            }
        }catch(ex){
            console.log('setAcctLinkList: ',ex);  
        }
    }

    const setServiceLinkList = () => {
       
        let payNowString = '';
        let labelArray = [];
        try {
            serviceLinkages.map(item =>{
                if(item.value === '300102') {
                    let UEN= response.CompDtls.RegNo? response.CompDtls.RegNo!==null? response.CompDtls.RegNo:'':'';
                    let Suffix = response.BizInternetBank.ServiceLinkList.PaynowRegistration.Suffix? response.BizInternetBank.ServiceLinkList.PaynowRegistration.Suffix !== null? response.BizInternetBank.ServiceLinkList.PaynowRegistration.Suffix:'':'';
    
                    payNowString = item.label+' - '+UEN+Suffix;
                    labelArray.push(payNowString);
                }
                else{
                    labelArray.push(item.label);
                }
            }) 
            serviceLinkageArray = labelArray;
 
        } catch(ex){
            console.log('setServiceLinkList: ',ex);  
        }
    }

    const checkTaxStatusReason = (reasonCode) => {
        let result = '';
        if(reasonCode){
            if(reasonCode.toUpperCase() === taxDetailsData.ableToProvideTinDDL.data[0].value){
                result = 'Yes';
            }
            else if(reasonCode.toUpperCase() === taxDetailsData.ableToProvideTinDDL.data[1].value) {
                result = 'No (Reason A)'
            }
            else if(reasonCode.toUpperCase() === taxDetailsData.ableToProvideTinDDL.data[2].value) {
                result = 'No (Reason B)'
            }
            else if(reasonCode.toUpperCase() === taxDetailsData.ableToProvideTinDDL.data[3].value) {
                result = 'No (Reason C)'
            }
        }
        return result;
    }

    const getSoleDocName = ()=>{
        if(response.DocSubmit){
            if(response.DocSubmit.Doc && response.DocSubmit.Doc.File !==null){
                return response.DocSubmit.Doc.File.name;
            }
            else {
                return '';
            }
        }
        
    }

    const getCheckedArray = (resChkObj) => {
        let array = [];
        for (const [key, value] of Object.entries(resChkObj)) {
            if(value === 'true') {
       
                array.push(key);
            }
        }
        return array;
    }
 
    const getObjInArray = (iValue, array) => {
        let result = {};
        if(iValue !== null){
            try {
                result = array.find( ({ value }) => value === iValue);
                return result;
            }
            catch(ex) {
                console.log('getObjInArray: ',ex);  
            }
        }
    }

    const getValueInArray = (iValue,array) => {
        const obj = array.find(({ value }) => value === iValue);
        let result = '';
        if(obj){
            result = obj.value;
        }
        return result;
    }

    const getChkLabelInArray = (iValue, array) => {
        const obj = array.find(({ id }) => id === iValue);
        let result = '';
   
        if(obj) {
            result = obj.lblname;
        }
        return result;
    }

    const getLabelInArray = (iValue, array) => {
        try{
            if(iValue == null){
                return '';
            }
    
            const obj = array.find(({ value }) => value === iValue);
            let result = '';
            if(obj){
                result = obj.label;
            }
            return result;
        } catch(ex){
            console.log('getLabelInArray: ',ex);
        }
    }

    const handleOnEdit = (id) =>{
        if(id === config.route.CompanyDetails) {
            let sid = storage.getStateId();
            history.push(config.route.CompanyDetails+'?state='+sid, { from: config.route.Preview });
        }
        else if(id === config.route.AccountOpening) {
            history.push(config.route.AccountOpening, { from: config.route.Preview });
        }
        else if(id === config.route.TxnActivities) {
            history.push(config.route.TxnActivities, { from: config.route.Preview });
        }
        else if(id === config.route.ApplicantDetails) {
            history.push(config.route.ApplicantDetails, { from: config.route.Preview })
        }
        else if(id === config.route.BizBankingService) {
            if(isSoleProps()){
                history.push(config.route.BizBankingService, { from: config.route.Preview })
            }
            else {
                history.push(config.route.NSBizBankingService, { from: config.route.Preview })
            }
        }
        else if(id === config.route.DelegationDetails) {
            if(isSoleProps()){
                history.push(config.route.DelegationDetails, { from: config.route.Preview })
            }
            else {
                history.push(config.route.NSDelegationDetails2, { from: config.route.Preview })
            }
        }
        else if(id ===  config.route.NSDelegationDetails){  //Board Resolutions
            history.push(config.route.NSDelegationDetails, { from: config.route.Preview })
        }
        else if(id === config.route.TaxDetails) {
            if(isSoleProps()){
                history.push(config.route.TaxDetails, { from: config.route.Preview })
            }
            else {
                history.push(config.route.NSTaxDetails, { from: config.route.Preview })
            }
        }
        else if(id === config.route.UploadDetails) {
            if(isSoleProps()){
                history.push(config.route.UploadDetails, { from: config.route.Preview })
            }
            else {
                routeUploadDtlsbyType();
            }
        }
        else if (id === config.route.NonAuthPersonDetails) {
            history.push(config.route.NonAuthPersonDetails, { from: config.route.Preview })
        }
        else if (id === config.route.AcctOpeningMY) {
            history.push(config.route.AcctOpeningMY, { from: config.route.Preview })
        }
   }

   const routeUploadDtlsbyType = () => {
        const uploadDtlsType = storage.getCompType();
       
        if(uploadDtlsType === uploadConfig.SCOType.SCO1) {
            history.push(config.route.NSUploadDetails, { from: config.route.Preview })
        }
        else if(uploadDtlsType === uploadConfig.SCOType.SCO2) {
            history.push(config.route.LLPUploadDetails, { from: config.route.Preview })
        }
        else if(uploadDtlsType === uploadConfig.SCOType.SCO3) {
            history.push(config.route.ACSUploadDetails, { from: config.route.Preview })
        }
        else { 
            history.push(config.route.NSUploadDetails, { from: config.route.Preview })
        }
    }

    const showUploadDeclaration = () => {
        if(isSoleProps()){
            return false;
        }
        else {
            const uploadDtlsType = storage.getCompType();
            if(uploadDtlsType === uploadConfig.SCOType.SCO1) { 
               
                return true;
            }
            else if(uploadDtlsType === uploadConfig.SCOType.SCO2) {
                return true;
            }
            else if(uploadDtlsType === uploadConfig.SCOType.SCO3) {
                 return true;
            }
            else { 
                return false;
            }
        }
    }

   const getSeqNoByIndex = (idx) => {
        return idx+1;
   }

   const isSoleProps = () => {
  
    if(response.CompDtls.SoleorNonSole === config.bizConst.Sole){
 
        return true;
    }
    else {
         
        return false;
    }
   }

   const getCRSStatusString =() => {
       let obj = {};
       let str = ''

       if(response.CRSFATCA.CRSStatus !== null){
        if(response.CRSFATCA.IsActiveBizEntity==='Y'){ 
            obj= getObjInArray(response.CRSFATCA.CRSStatus,taxDetailsData.crsStatusYes);
        
       }
       else {
            obj=getObjInArray(response.CRSFATCA.CRSStatus,taxDetailsData.crsStatusNo);
       }
 
       if(obj) {
           str = obj.label;
       }
       }
      return str;
   }

   const getFATCABIZString= ()=> {
       try{
        let str ='';
        if(response.CRSFATCA.FATCABIZ !==null){
         if(getObjInArray(response.CRSFATCA.FATCABIZ,taxDetailsData.fatcaBizStatus)){
             str = getObjInArray(response.CRSFATCA.FATCABIZ,taxDetailsData.fatcaBizStatus).label;
         }
        }
        return str;
       }
       catch(exception){
            console.log('getFATCABIZString: ',exception);
       }
   }

   const createHolders = (data) => {
    let temp = [];
    let myInfoAppDtls = {
        IDNum:data.ApplicantsDtlsMyInfo.IDNum,
        Name:data.ApplicantsDtlsMyInfo.Name,
        Designation:data.ApplicantsDtlsMyInfo.Designation !==null? data.ApplicantsDtlsMyInfo.Designation:'',
        Nationality:data.ApplicantsDtlsMyInfo.Nationality !==null? data.ApplicantsDtlsMyInfo.Nationality:''
    }
    if(!Array.isArray(data.Holdersdetails)) {
        // temp.push(myInfoAppDtls); //no need to add login user
        if(data.Holdersdetails.IDNum !== null) {
            temp = data.Holdersdetails;
            holders.push(temp);
        }
    }
    else {
        // temp.push(myInfoAppDtls); //no need to add login user
        for(let i in data.Holdersdetails) {
            if(data.Holdersdetails[i].IDNum !== null){
                temp.push(data.Holdersdetails[i]);
            }
        }
        holders = temp;
    }
 
   }

   const showNonAuthPerson = () => {
       let isShow = false;
       if(!isSoleProps()) {//non sole props
        if(Object.entries(appDtls0).length !== 0) { // has non auth person
            isShow = true;
        }
        else {
            isShow = false;
        }
       }
       return isShow;
   }

   
    const toHHMMSS = (val) => {
        var sec_num = parseInt(val / 1000, 10); 
        var hours = Math.floor(sec_num / 3600);
        var minutes = Math.floor((sec_num - hours * 3600) / 60);
        var seconds = sec_num - hours * 3600 - minutes * 60;

        if (hours < 10) {
            hours = "0" + hours;
        }
        if (minutes < 10) {
             minutes = "0" + minutes;
        }
        if (seconds < 10) {
            seconds = "0" + seconds;
        }
        return minutes + ":" + seconds;
    }
 
    const isNumber = async (evt) => { // allow number
        evt = evt ? evt : window.event;
        var charCode = evt.which ? evt.which : evt.keyCode;
    
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
          await setOTPValue("");
          await setOtpconfirmDisabled(false);
          return false;
        } else {
          await setOtpconfirmDisabled(true);
          return true;
        }
    };

    const generateOTP = (authToken, mobileNo) => {
        setIsOtpLoading(true);
        let mobileNum = mobileNo; //response.MobileNonsm
        let accessId = "5911";
        let countryCode = "00065";
        let legalID = "T0499906H";
        optService.OTPGeneration(mobileNum, accessId, countryCode, legalID,authToken)
            .then(async (res) => {
                setIsOtpLoading(false);
                const data = res.data;
                if (!data.didError) {
                    let res = data.model.msg;
                    let resMsgBdy = res.msgBody;
                    let resMsgHdr = res.msgHdr;
                    if (resMsgHdr.statusDesc === "Success") {
                        start();
                        setIsOtpGeneratedSuccess(true);
                    }
                    else {
                        showErrMsg('Unable to generate OTP. Please try again.');
                        setShowOTPBar(false);
                        setIsOtpGeneratedSuccess(false);
                    }
                }
            })
            .catch((err) => {
                console.log(err);
                showErrMsg('Unable to generate OTP. Please try again.')
                setIsOtpLoading(false);
                setShowOTPBar(false);
                setIsOtpGeneratedSuccess(false);
            });
    }

    const verifyOTPDetails = async () => {
        
        if (OTPValue) {
            setIsOtpLoading(true);
          // let req = setAllOTPResponces;
          let mobileNum = getCurrentUserMobileNo(); //response.MobileNonsm
          let accessId = "5911";
          let countryCode = "00065";
          let legalID = "T0499906H";
          let OTP = OTPValue;
  
            optService
            .OTPVerification(mobileNum, OTP, accessId, countryCode, legalID,otpAuthToken)
            .then(async (res) => {
                setIsOtpLoading(false);
                const data = res.data;
                if (!data.didError) {
                    let res = data.model.msg;
                    let resMsgBdy = res.msgBody;
                    let resMsgHdr = res.msgHdr;
             
                    if (resMsgHdr.statusCode === "0") {
                        submitWithFields(false);
                    } else {
                        showOTPErrMsg();
                    }
              }
            })
            .catch((err) => {
                console.log('@verifyOTPDetails: ',err);
                setIsOtpLoading(false);
                setShowOTPBar(false);
                showErrMsg("Unable to verify OTP. Please try again.");
                count3TimeToExist = 0;
            });
    
        } else {
          await setOtpconfirmDisabled(true);
          showErrMsg("Please enter valid numeric 6 digit OTP");
        }
      };

    const showOTPErrMsg = () => {
        if (count3TimeToExist <= 3) {
            setOTPValue('');
            if(count3TimeToExist === 1) {
                showErrMsg("1/3 incorrect OTP")
            }
            else if(count3TimeToExist === 2) {
                showErrMsg("2/3 incorrect OTP")
            }
            else if(count3TimeToExist === 3) {
                showErrMsg("3/3 incorrect OTP. Your application is unsuccessful due to maximum number of OTP attempts. Do reapply.")
            }
        } else {
            gotoInvalidOTP()
            return;
        }
    }
    
    const gotoInvalidOTP = () => {
        if(response.ApplicantsDtlsMyInfo.isFirstUser === 'true') {
            history.push(config.route.InvalidOTP,{from: config.route.Preview,isFU:true});
        }
        else {
            history.push(config.route.InvalidOTP,{from: config.route.Preview,isFU:false});
        }
    }
    
    const handleOTPInput =  async (e) => {  // get and set OTP number 
        const re = /^[0-9\b]+$/;
        if (e.target.value === "" || re.test(e.target.value)) {
          await setOTPValue(e.target.value);
        }
 
        if (e.target.value.length === 6) {
          await setOtpconfirmDisabled(true);
        } else {
          await setOtpconfirmDisabled(false);
        }
    };

    const getOTPSecurityToken =()=>{
 
        optService.OTPSecurity().then(res => {
            setIsLoading(false);
            let resData = res.data;
            if(resData){
                otpAuthToken = resData.token;
            }           
        })
        .catch(err => {
            console.log('@getOTPSecurityToken: ',err);
            setIsLoading(false);
        });
    }

    const getTodayDate = () => {
        const  months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        let today = new Date();
        let dd =  String(today.getDate()).padStart(2, '0');
        let mm =  months[today.getMonth()];
        let yyyy = today.getFullYear();
        today = dd + ' ' + mm + ' '+yyyy;
        return today;
    }

    const otpDisplayMsg = () => {
        let msg = '';
        if(showOTPResendRequestErr) {
            msg = 'You have already submitted an OTP request earlier. To avoid multiple requests, please wait a few minutes for your OTP to be sent to you before making another request.' 
        }
        else {
            msg = 'OTP has been sent to '+helper.mask(getCurrentUserMobileNo(),4)+' ('+getTodayDate()+' '+currentTime+'). If you did not receive,';
        }
       
        return msg;
    }

    const getCurrentTime = () => {
        const today = new Date();
        let h = today.getHours();
        let m = today.getMinutes();
        let s = today.getSeconds();
        m = checkTime(m);
        s = checkTime(s);
        setCurrentTime(h+':'+m+':'+s);
        setTimeout(getCurrentTime,1000);
    }

    function checkTime(i) {
        if (i < 10) {i = "0" + i};  // add zero in front of numbers < 10
        return i;
    }

    if(isLoading) {
        return(
            <Loading />
        )
    }
    else {
        if(!isError) {
            bindData();
        }
    }

    return (
        <div className="container-fluid">
           <div className="outerdivsubheader">
                <div className="row">
                    <div className="col-12">
                        <h2 className='welcome mb-0'>You're almost there!<br/>Please check your info before we proceed</h2>
                    </div>
                </div>
            </div> <br/>
        
            <Form 
                 render={(formRenderProps)=>(
                        <FormElement>
                            <FormContainer>
                                <fieldset>
                                    <Field component={CusFormTitle} id={'fst1'} name={previewData.formContainerTitle.T1.name} showEdit={false} />
                                    
                                    <div className="row" style={{borderBottom:'2px solid #FFC83D',paddingTop:'10px'}} />

                                    <FieldWrapper>
                                    <Field component={CusFormLabelRtl} 
                                        leftLabelId={'lblRegNo'} leftLabelName={previewData.label.RegNo}
                                        id={'RegNo'} name={response.CompDtls.RegNo !==null? response.CompDtls.RegNo:''} />

                                    <Field component={CusFormLabelRtl} 
                                        leftLabelId={'lblCompName'} leftLabelName={previewData.label.CompName}
                                        id={'CompName'} name={response.CompDtls.CompName !== null? response.CompDtls.CompName:''} />

                                    <Field component={CusFormLabelRtl} 
                                        leftLabelId={'lblCompType'} leftLabelName={previewData.label.CompType}
                                        id={'lblcompType'} name={response.CompDtls.CompType !==null? response.CompDtls.CompType:response.RegBizMailAddr.CompType !==null?response.RegBizMailAddr.CompType:''} />

                                    <Field component={CusFormLabelRtl} 
                                        leftLabelId={'lblDtOfInc'} leftLabelName={previewData.label.DtOfInc}
                                        id={'dtOfInc'} name={response.CompDtls.DtOfInc !==null? response.CompDtls.DtOfInc:''} />
                                    
                                    <Field component={CusFormLabelRtl} 
                                        leftLabelId={'lblCountryOfInc'} leftLabelName={previewData.label.CountryOfInc}
                                        id={'countryOfInc'} name={response.CompDtls.CountryOfInc!==null? getLabelInArray(response.CompDtls.CountryOfInc,myInfoCountries):'SINGAPORE' } />
                                    </FieldWrapper>
                                </fieldset>
                            </FormContainer>

                            <FormContainer>
                            <fieldset>
                                <Field component={CusFormTitle} id={'fst2'} name={previewData.formContainerTitle.T2.name} 
                                        showEdit={false}  />

                                    <div className="row" style={{borderBottom:'2px solid #FFC83D',paddingTop:'10px'}} />

                                    <FieldWrapper>
                                    {response.RegBizAddr.AddType !== config.addTypeLocal?
                                    <div>
                                    <Field component={CusFormLabelRtl} 
                                        leftLabelId={'lblAddline1'} leftLabelName={previewData.label.AddLine1}
                                        id={'addline1'} name={response.RegBizAddr.AddLine1 !==null? response.RegBizAddr.AddLine1:''}/>

                                    <Field component={CusFormLabelRtl} 
                                        leftLabelId={'lblAddline1'} leftLabelName={previewData.label.AddLine2}
                                        id={'addline1'} name={response.RegBizAddr.AddLine2 !==null? response.RegBizAddr.AddLine2:''}/>
                                  
                                    </div>
                                    :  
                                    <div>
                                    <Field component={CusFormLabelRtl} 
                                        leftLabelId={'lblBlk'} leftLabelName={previewData.label.BlkNo} 
                                        id={'blk'} name={response.RegBizAddr.BlkNo !== null? response.RegBizAddr.BlkNo:''}/>

                                    <Field component={CusFormLabelRtl} 
                                        leftLabelId={'lblStreet'} leftLabelName={previewData.label.Street}
                                        id={'st'} name={response.RegBizAddr.Street !== null? response.RegBizAddr.Street:''} />
                             
                                    <Field component={CusFormLabelRtl} 
                                        leftLabelId={'lblLvl'} leftLabelName={previewData.label.FlrNum} 
                                        id={'lvl'} name={response.RegBizAddr.FlrNum !== null? response.RegBizAddr.FlrNum:''}  />

                                    <Field component={CusFormLabelRtl} 
                                        leftLabelId={'lblUno'} leftLabelName={previewData.label.UnitNo}
                                        id={'uno'} name={response.RegBizAddr.UnitNo !==null? response.RegBizAddr.UnitNo:''}  />
                               
                                    <Field component={CusFormLabelRtl} 
                                        leftLabelId={'lblbuilding'} leftLabelName={previewData.label.BldName} 
                                        id={'bld'} name={response.RegBizAddr.BldName !==null? response.RegBizAddr.BldName:''}  />

                                     <Field component={CusFormLabelRtl} 
                                        leftLabelId={'lblPostalCode'} leftLabelName={previewData.label.PostalCode}
                                        id={'ptc'} name={response.RegBizAddr.PostalCode !==null? response.RegBizAddr.PostalCode:''} />

                                    <Field component={CusFormLabelRtl} 
                                        leftLabelId={'lblcountry'} leftLabelName={previewData.label.Country}
                                        id={'ctry'} name={response.RegBizAddr.Country !==null? getLabelInArray(response.RegBizAddr.Country,myInfoCountries):''}/>
                                    </div>
                                    }
                                    </FieldWrapper>
                                </fieldset>
                            </FormContainer>
                         
                            <FormContainer>
                            <fieldset>
                                <Field component={CusFormTitle} id={'CompanyDetails'} name={previewData.formContainerTitle.T3.name} 
                                        showEdit={showEditTitle()}  onEdit={handleOnEdit} />    
                                <div className="row" style={{borderBottom:'2px solid #FFC83D',paddingTop:'10px'}} />
                                {response.RegBizMailAddr.SameAsRegBizAddr === 'N'? 
                                <FieldWrapper>  
                                
                                <Field component={CusFormLabelRtl} 
                                    leftLabelId={'lblSameAsRegBizAddr'} leftLabelName={previewData.label.SameAsRegBizAddr} 
                                    id={'SameAsRegBizAddr'} name={response.RegBizMailAddr.SameAsRegBizAddr == 'Y'? 'Yes':'No'} />
                          
                                <Field component={CusFormLabelRtl} 
                                    leftLabelId={'lblBlk'} leftLabelName={previewData.label.BlkNo} 
                                    id={'blk'} name={response.RegBizMailAddr.BlkNo !==null? response.RegBizMailAddr.BlkNo:''}/>

                                <Field component={CusFormLabelRtl} 
                                    leftLabelId={'lblStreet'} leftLabelName={previewData.label.Street}
                                    id={'st'} name={response.RegBizMailAddr.Street !==null? response.RegBizMailAddr.Street:''} />
                             
                                <Field component={CusFormLabelRtl} 
                                    leftLabelId={'lblLvl'} leftLabelName={previewData.label.FlrNum} 
                                    id={'lvl'} name={response.RegBizMailAddr.FlrNum !==null? response.RegBizMailAddr.FlrNum:''}  />

                                <Field component={CusFormLabelRtl} 
                                    leftLabelId={'lblUno'} leftLabelName={previewData.label.UnitNo}
                                    id={'uno'} name={response.RegBizMailAddr.UnitNo !==null? response.RegBizMailAddr.UnitNo:''}  />
                               
                                <Field component={CusFormLabelRtl} 
                                    leftLabelId={'lblbuilding'} leftLabelName={previewData.label.BldName} 
                                    id={'bld'} name={response.RegBizMailAddr.BldName !==null? response.RegBizMailAddr.BldName:''}  />

                                <Field component={CusFormLabelRtl} 
                                    leftLabelId={'lblPostalCode'} leftLabelName={previewData.label.PostalCode}
                                    id={'ptc'} name={response.RegBizMailAddr.PostalCode !==null? response.RegBizMailAddr.PostalCode:''} />

                                <Field component={CusFormLabelRtl} 
                                    leftLabelId={'lblcountry'} leftLabelName={previewData.label.Country}
                                    id={'ctry'} name={response.RegBizMailAddr.Country!==null? getLabelInArray(response.RegBizMailAddr.Country,countries):''}/>
                                </FieldWrapper> :

                                <FieldWrapper>  
                          
                                <Field component={CusFormLabelRtl} 
                                    leftLabelId={'lblSameAsRegBizAddr'} leftLabelName={previewData.label.SameAsRegBizAddr} 
                                    id={'SameAsRegBizAddr'} name={response.RegBizMailAddr.SameAsRegBizAddr == 'Y'? 'Yes':'No'} />
                                </FieldWrapper>}
                            </fieldset>
                            </FormContainer>
                            <FormContainer>
                            <fieldset>
                                <Field component={CusFormTitle} id={'AccountOpening'} name={previewData.formContainerTitle.T4.name} 
                                        showEdit={showEditTitle()}  onEdit={handleOnEdit} />    

                                <div className="row" style={{borderBottom:'2px solid #FFC83D',paddingTop:'10px'}} />

                                <FieldWrapper>  
 
                                <Field component={CusFormLabelFours} 
                                    leftLabelId={'lblPrefBranch'} leftLabelName={previewData.label.PrefBranch}
                                    leftLabelId2={'lblPrefBranchAddr'} leftLabelName2={''} 
                                    id={'PrefBranch'} name={response.BizAccts.PrefBranch !== null? getLabelInArray(response.BizAccts.PrefBranch,branches):''}
                                    id2={'PrefBranchAddr'} name2={response.BizAccts.PrefBranch && response.BizAccts.PrefBranch !== null? getObjInArray(response.BizAccts.PrefBranch,branches).addr:''} />

                                <Field component={CusFormLabelRtl} 
                                    leftLabelId={'lblPrefSGDAcct'} leftLabelName={previewData.label.PrefSGDAcct}
                                    id={'PrefSGDAcct'} name={response.BizAccts.PrefSGDAcct !==null? getLabelInArray(response.BizAccts.PrefSGDAcct,sgdaccount):''} />

                                {/* CR - Chequebook */}
                                {/* CR - Chequebook removal - 01 oct 2025 */}
                                {/* <Field component={CusFormLabelRtl} 
                                    leftLabelId={'lblReqChequebook'} leftLabelName={previewData.label.ReqForChequebook}
                                    id={'ReqChequebook'} name={response.BizAccts.ReqForChequeBook !==null? getLabelInArray(response.BizAccts.ReqForChequeBook,accOpeningData.reqChequebookDDL.data):''} /> */}

                                {response.BizAccts.PrefFrngAcct !==null &&
                                    <Field component={CusFormLabelRtl} 
                                    leftLabelId={'lblPrefFrngAcct'} leftLabelName={previewData.label.PrefFrngAcct}
                                    id={'PrefFrngAcct'} name={response.BizAccts.PrefFrngAcct !==null? response.BizAccts.PrefFrngAcctDesc:''}/>}
                                
                                {/* CR - Chequebook */}
                                {(response.BizAccts.ReqForFrngAcctChequeBook !== undefined && response.BizAccts.ReqForFrngAcctChequeBook !== null && response.BizAccts.ReqForFrngAcctChequeBook !== '') &&
                                <Field component={CusFormLabelRtl} 
                                    leftLabelId={'lblReqChequebook'} leftLabelName={previewData.label.ReqForChequebook}
                                    id={'ReqChequebook'} name={response.BizAccts.ReqForFrngAcctChequeBook !==null? getLabelInArray(response.BizAccts.ReqForFrngAcctChequeBook,accOpeningData.reqChequebookDDL.data):''} />
                                }
                                </FieldWrapper>
                             </fieldset>
                             </FormContainer>
                            <FormContainer>
                                <fieldset>
                                    <Field component={CusFormTitle} id={'AccountOpening'} name={previewData.formContainerTitle.T5.name} 
                                        showEdit={showEditTitle()} onEdit={handleOnEdit} />    
                                        
                                        <div className="row" style={{borderBottom:'2px solid #FFC83D',paddingTop:'10px'}} />

                                <FieldWrapper>
                                <Field component={CusFormLabelRtl} 
                                    leftLabelId={'lblPrpsAcctOpen'} leftLabelName={previewData.label.PrpsAcctOpen}
                                    id={'PrpsAcctOpen'} name={prpsAcctOpenStr}/>
                                    
                                <Field component={CusFormLabelRtl} 
                                    leftLabelId={'lblWealthOutSG'} leftLabelName={previewData.label.WealthOutSG}
                                    id={'WealthOutSG'} name={response.WealthOutSG === 'N'? 'No':'Yes'}/>

                                {response.WealthOutSG === 'N' &&
                                <Field component={CusFormLabelRtl} 
                                    leftLabelId={'lblWealthCnty'} leftLabelName={previewData.label.WealthCnty}
                                    id={'WealthCnty'} name={wealthCntyStr}/> }
                                    
                                <Field component={CusFormLabelRtl} 
                                    leftLabelId={'lblPrimaryBizAct'} leftLabelName={previewData.label.PrimaryBizAct}
                                    id={'PrimaryBizAct'} name={response.PrimaryBizAct !==null? response.PrimaryBizAct:''}/>

                                <Field component={CusFormLabelRtl} 
                                    leftLabelId={'lblSecondaryBizAct'} leftLabelName={previewData.label.SecondaryBizAct}
                                    id={'SecondaryBizAct'} name={response.SecondaryBizAct !==null? response.SecondaryBizAct:''}/>

                                {(response.ReferralCode && response.ReferralCode !=='')&&
                                <Field component={CusFormLabelRtl} 
                                    leftLabelId={'lblReferralCode'} leftLabelName={previewData.label.ReferralCode}
                                    id={'ReferralCode'} name={response.ReferralCode !==null? response.ReferralCode:''}/>
                                }
                                </FieldWrapper>
                                </fieldset>
                            </FormContainer>
                            
                            <FormContainer>
                                <fieldset>
                                <Field component={CusFormTitle} id={'TxnActivities'} name={previewData.formContainerTitle.T6.name} 
                                        showEdit={showEditTitle()} onEdit={handleOnEdit} />    

                                <div className="row" style={{borderBottom:'2px solid #FFC83D',paddingTop:'10px'}} />

                                <FieldWrapper>
                                <Field component={CusFormLabelRtl} 
                                    leftLabelId={'lblBizInc'} leftLabelName={previewData.label.BizInc}
                                    id={'BizInc'} name={bizIncStr} />

                                <Field component={CusFormLabelRtl} 
                                    leftLabelId={'lblBizPay'} leftLabelName={previewData.label.BizPay}
                                    id={'BizPay'} name={bizPayStr} />

                                <Field component={CusFormLabelRtl} 
                                    leftLabelId={'lblAntTranMo'} leftLabelName={previewData.label.AntTranMo}
                                    id={'AntTranMo'} name={antTranMoStr} />

                                <Field component={CusFormLabelRtl} 
                                    leftLabelId={'lblAntSGDTran'} leftLabelName={previewData.label.AntSGDTran}
                                    id={'AntSGDTran'} name={antSGDTranStr} />

                                <Field component={CusFormLabelRtl} 
                                    leftLabelId={'lblMajorBuyers'} leftLabelName={previewData.label.MajorBuyers}
                                    id={'MajorBuyers'} name={majorBuyersStr} />
                                </FieldWrapper>
                                </fieldset>
                            </FormContainer>
                            {!isSoleProps()?
                                <div>
                                {Object.entries(appDtls1).length !== 0 && <ApplicantDtlsPreview seq={'1'} applicantDtls={appDtls1} hasMyInfo={hasMyInfo1} isFirstUser={isFirstUser(appDtls1,response.ApplicantsDtlsMyInfo)} isSoleProps={isSoleProps()} holders={holders} />}
                                {Object.entries(appDtls2).length !== 0 && <ApplicantDtlsPreview seq={'2'} applicantDtls={appDtls2} hasMyInfo={hasMyInfo2} isFirstUser={isFirstUser(appDtls2,response.ApplicantsDtlsMyInfo)} isSoleProps={isSoleProps()} holders={holders} />}
                                {Object.entries(appDtls3).length !== 0 && <ApplicantDtlsPreview seq={'3'} applicantDtls={appDtls3} hasMyInfo={hasMyInfo3} isFirstUser={isFirstUser(appDtls3,response.ApplicantsDtlsMyInfo)} isSoleProps={isSoleProps()} holders={holders} />}
                                </div> :
                                <ApplicantDtlsPreview seq={'1'} applicantDtls={appDtls1} hasMyInfo={hasMyInfo1} isFirstUser={isFirstUser(appDtls1,response.ApplicantsDtlsMyInfo)} isSoleProps={isSoleProps()} holders={holders} />}

                            <FormContainer>
                            <fieldset>
                                <Field component={CusFormTitle} id={'BizBankingService'} name={previewData.formContainerTitle.T8.name} 
                                        showEdit={showEditTitle()} onEdit={handleOnEdit} /> 

                                <div className="row" style={{borderBottom:'2px solid #FFC83D',paddingTop:'10px'}} />

                                <FieldWrapper> 
                                <Field component={FormSubTitleDesp} id={'fstSTD2BizBankingService'} 
                                    name={bizBankingData.note}  />
                                </FieldWrapper>

                                <FieldWrapper>  
                                
                                <Field component={CusFormLabelRtl} 
                                    leftLabelId={'lblcoNameOnCard'} leftLabelName={bizBankingData.label.coNameOnCard} 
                                    id={'coNameOnCard'} name={response.MaybankBussinessPlatinumCard.CompanyNametoAppear !==null?response.MaybankBussinessPlatinumCard.CompanyNametoAppear:''}/>

                                {bizCardApplicantsArray.map((item, idx) => (
                                <Field component={CusFormLabelFours} key={idx} 
                                    leftLabelId={'lblAuthUser'} leftLabelName={bizBankingData.label.dcApplicant+' '+getSeqNoByIndex(idx)}
                                    leftLabelId2={'lblnOnCard'} leftLabelName2={bizBankingData.label.nOnCard} 
                                    id={'AuthUser'} name={item.Name}
                                    id2={'nOnCard'} name2={item.NametoAppear} />
                                ))}

                                </FieldWrapper>
                            </fieldset>
                            </FormContainer>

                            <FormContainer>
                            <fieldset>
                                <Field component={CusFormTitle} id={'BizBankingService'} name={previewData.formContainerTitle.T9.name} 
                                        showEdit={showEditTitle()} onEdit={handleOnEdit} /> 

                                <div className="row" style={{borderBottom:'2px solid #FFC83D',paddingTop:'10px'}} />

                                <FieldWrapper> 
                                <Field component={FormSubTitle} id={'fstSTD3BizBankingService'} 
                                    name={bizBankingData.formSubTitle.ST2}  />

                                    <FieldWrapper>
                                    <Field component={CusFormLabelRtl} 
                                        leftLabelId={'lblApprovalMandate'} leftLabelName={bizBankingData.label.approvalM} 
                                        id={'ApprovalMandate'} name={getLabelInArray(response.BizInternetBank.ApprovalMandate,mandates)}/>
                                        
                                    <AccountLinkage leftLabelId={'lblServiceLinkList'} leftLabelName={bizBankingData.label.accLinkage}
                                        displayArray={acctLinkListArray} />    

                                    <ServiceLinkage leftLabelId={'lblServiceLinkList'} leftLabelName={bizBankingData.label.serLinkage} 
                                       displayArray={serviceLinkageArray}>

                                    </ServiceLinkage>
                                    </FieldWrapper>
                                </FieldWrapper>
                                 <FieldWrapper></FieldWrapper>  
                                <Field component={FormSubTitle} id={'fstSTD4BizBankingService'} 
                                    name={bizBankingData.formSubTitle.ST3}  />
                         
                                {userRegistrationArray.map((item, idx) => (
                                <Field component={CusFormLabelRtl} 
                                     leftLabelId={'lblAuthUser'} key={idx} leftLabelName={bizBankingData.label.dcApplicant+' '+getSeqNoByIndex(idx)} 
                                    id={'AuthUser'} name={item.Name}/>  
                                ))}

                                </fieldset>
                                </FormContainer>
                            {!isSoleProps() &&
                            <FormContainer>
                            <fieldset>
                                <Field component={CusFormTitle} id={'NSDelegationDetails'} name={previewData.formContainerTitle.T10A.name} 
                                    showEdit={showEditTitle()} onEdit={handleOnEdit} /> 

                                <div className="row" style={{borderBottom:'2px solid #FFC83D',paddingTop:'10px'}} />
                                <FieldWrapper>    
                                <Field component={CusFormLabelRtl} 
                                     leftLabelId={'lblCertifyPerson'} leftLabelName={previewData.label.CertifyPerson} 
                                    id={'CertifyPerson'} name={certifyPersonStr} />

                                <Field component={CusFormLabelRtl} 
                                     leftLabelId={'lblnsConOfSign'} leftLabelName={previewData.label.nsConOfPer} 
                                    id={'SignConditionAP'} name={getLabelInArray(response.SignConditionAP,sign)}/>  

                                <Field component={CusFormLabelRtl} 
                                     leftLabelId={'lblApptAuthPerson'} leftLabelName={previewData.label.ApptAuthPerson} 
                                    id={'ApptAuthPerson'} name={apptAuthPersonStr} />

                                <Field component={CusFormLabelRtl} 
                                     leftLabelId={'lblBRTerms'} leftLabelName={delegateData.label.terms} 
                                    id={'BRTerms'} name={'I/We agree'} />
                                </FieldWrapper>    
                            </fieldset>
                            </FormContainer> }

                            <FormContainer>
                            <fieldset>
                                <Field component={CusFormTitle} id={'DelegationDetails'} name={isSoleProps()?'Delegation of Authority':previewData.formContainerTitle.T10.name} 
                                    showEdit={showEditTitle()} onEdit={handleOnEdit} /> 
                                    
                                <div className="row" style={{borderBottom:'2px solid #FFC83D',paddingTop:'10px'}} />
                                {isSoleProps()?
                                <FieldWrapper>      
                                <Field component={CusFormLabelRtl} 
                                     leftLabelId={'lblSignConditionAP'} leftLabelName={previewData.label.nsConOfSign} 
                                    id={'SignConditionAP'} name={getLabelInArray(response.SignConditionAP,sign)}/>  

                                <Field component={CusFormLabelRtl} 
                                     leftLabelId={'lblApptAuthPerson'} leftLabelName={previewData.label.ApptAuthPersonSole} 
                                    id={'ApptAuthPerson'} name={response.ApplicantDtls && response.ApplicantDtls.Name!==null?response.ApplicantDtls.Name:''}/>  

                                <Field component={CusFormLabelRtl} 
                                     leftLabelId={'lblAuthSign'} leftLabelName={previewData.label.AuthSign} 
                                    id={'AuthSign'} name={response.ApplicantDtls && response.ApplicantDtls.Name!==null?response.ApplicantDtls.Name:''}/>  

                                <Field component={CusFormLabelRtl} 
                                     leftLabelId={'lblBenificialOwner'} leftLabelName={previewData.label.BenificialOwner} 
                                    id={'BenificialOwner'} name={response.ApplicantDtls && response.ApplicantDtls.Name!==null?response.ApplicantDtls.Name:''} />

                                <Field component={CusFormLabelRtl} 
                                        leftLabelId={'lblIsAboveABeneficialOwner'} leftLabelName={delegateData.label.rdoSoleBeneOwner} 
                                        id={'IsAboveABeneficialOwner'} name={response.IsAboveABeneficialOwner === 'N'? 'No':'Yes'} />  
                                </FieldWrapper>
                                :
                                <FieldWrapper>  
                                   <Field component={CusFormLabelRtl} 
                                     leftLabelId={'lblASBOConOfSign'} leftLabelName={previewData.label.nsConOfSign} 
                                    id={'ASBOConOfSign'} name={response.ASBOConOfSign !== null? getLabelInArray(response.ASBOConOfSign,sign):''}/>
 
                                    <Field component={CusFormLabelRtl} 
                                        leftLabelId={'lblAuthSign'} leftLabelName={previewData.label.AuthSign} 
                                        id={'AuthSign'} name={deleDtlsAuthSignStr} /> 

                                    <Field component={CusFormLabelRtl} 
                                        leftLabelId={'lblBenificialOwner'} leftLabelName={previewData.label.BenificialOwner} 
                                        id={'BenificialOwner'} name={benificialOwnerStr} />

                                    <Field component={CusFormLabelRtl} 
                                        leftLabelId={'lblIsAboveABeneficialOwner'} leftLabelName={delegateData.label.rdoBeneOwner} 
                                        id={'IsAboveABeneficialOwner'} name={response.IsAboveABeneficialOwner === 'N'? 'No':'Yes'} />
                                      
                                </FieldWrapper>
                                }
                                </fieldset>
                            </FormContainer>
                            <FormContainer>
                            <fieldset>
                                <Field component={CusFormTitle} id={'TaxDetails'} name={previewData.formContainerTitle.T11.name} 
                                    showEdit={showEditTitle()} onEdit={handleOnEdit} /> 

                                <div className="row" style={{borderBottom:'2px solid #FFC83D',paddingTop:'10px'}} />

                                <Field component={FormSubTitle} id={'st1TaxDetails'} name={taxDetailsData.formSubTitle.ST1}   />

                                <FieldWrapper>

                                <Field component={CusFormLabelRtl} 
                                     leftLabelId={'lblCouOfTaxRes'} leftLabelName={taxDetailsData.label.cnOfTaxResi} 
                                    id={'CouOfTaxRes'} name={getLabelInArray(response.TaxStatus.CouOfTaxRes,countries)}/>  

                                <Field component={CusFormLabelRtl} 
                                     leftLabelId={'lblTIN'} leftLabelName={taxDetailsData.label.taxIN} 
                                    id={'TIN'} name={response.TaxStatus.TIN}/>  

                                <Field component={CusFormLabelRtl} 
                                     leftLabelId={'lblPayTaxSGOnly'} leftLabelName={taxDetailsData.label.payTaxSGOnly} 
                                    id={'PayTaxSGOnly'} name={response.TaxStatus.PayTaxSGOnly === 'Y'?'Yes':'No'}/>  
                                </FieldWrapper>

                                {response.TaxStatus.PayTaxSGOnly === 'N' &&
                                <div>

                                <FieldWrapper>
                                <Field component={CusFormLabelRtl} 
                                     leftLabelId={'lblCouOfTaxRes2'} leftLabelName={taxDetailsData.label.cnOfTaxResi2} 
                                    id={'CouOfTaxRes2'} name={applicantTIN1.CouOfTaxRes !==null? getLabelInArray(applicantTIN1.CouOfTaxRes,countries):''}/>  


                                <Field component={CusFormLabelRtl} 
                                     leftLabelId={'lblAbleProvTIN'} leftLabelName={taxDetailsData.label.ableTIN} 
                                    id={'AbleProvTIN'} name={applicantTIN1.AbleProvTIN !==null? checkTaxStatusReason(applicantTIN1.AbleProvTIN):''}/>  

                                    
                                <Field component={CusFormLabelRtl} 
                                     leftLabelId={'lblTIN'} leftLabelName={taxDetailsData.label.taxIN} 
                                    id={'TIN'} name={applicantTIN1.TaxNumber !==null?  applicantTIN1.TaxNumber:''}/>  
 
                                {applicantTIN1.AbleProvTIN === taxDetailsData.ableToProvideTinDDL.data[2].value &&
                                <Field component={CusFormLabelRtl} 
                                     leftLabelId={'lblReasonUnableProvTIN'} leftLabelName={taxDetailsData.label.whyUnableTIN} 
                                    id={'ReasonUnableProvTIN'} name={applicantTIN1.ReasonUnableProvTIN !==null ?applicantTIN1.ReasonUnableProvTIN:''}/>}
                                </FieldWrapper>

                                {Object.keys(applicantTIN2).length !== 0 &&
                                <FieldWrapper>
                                <Field component={CusFormLabelRtl} 
                                     leftLabelId={'lblCouOfTaxRes2'} leftLabelName={taxDetailsData.label.cnOfTaxResi2} 
                                    id={'CouOfTaxRes2'} name={applicantTIN2.CouOfTaxRes !== null? getLabelInArray(applicantTIN2.CouOfTaxRes,countries):''}/> 

                                <Field component={CusFormLabelRtl} 
                                     leftLabelId={'lblAbleProvTIN'} leftLabelName={taxDetailsData.label.ableTIN} 
                                    id={'AbleProvTIN'} name={applicantTIN2.AbleProvTIN !==null? checkTaxStatusReason(applicantTIN2.AbleProvTIN):''}/>  

                                    
                                <Field component={CusFormLabelRtl} 
                                     leftLabelId={'lblTIN'} leftLabelName={taxDetailsData.label.taxIN} 
                                    id={'TIN'} name={applicantTIN2.TaxNumber !==null? applicantTIN2.TaxNumber:''}/>  
 
                                {applicantTIN2.AbleProvTIN === taxDetailsData.ableToProvideTinDDL.data[2].value ?
                                <Field component={CusFormLabelRtl} 
                                     leftLabelId={'lblReasonUnableProvTIN'} leftLabelName={taxDetailsData.label.whyUnableTIN} 
                                    id={'ReasonUnableProvTIN'} name={applicantTIN2.ReasonUnableProvTIN !== null? applicantTIN2.ReasonUnableProvTIN:''}/> :null}
                                </FieldWrapper>}
                                </div>
                                }

                                {isSoleProps()? <div>
                                <Field component={FormSubTitle} id={'st2TaxDetails'} name={taxDetailsData.formSubTitle.ST2}   />
                                <FieldWrapper>
                                <Field component={CusFormLabelRtl} 
                                     leftLabelId={'lblFATCAUSC'} leftLabelName={fatcaList[0].lblname} 
                                    id={'FATCAUSC'} name={response.CRSFATCA.FATCAUSC==='Y'?'Yes':'No'}/> 

                                <Field component={CusFormLabelRtl} 
                                     leftLabelId={'lblFATCAUSPR'} leftLabelName={fatcaList[1].lblname} 
                                    id={'FATCAUSPR'} name={response.CRSFATCA.FATCAUSPR==='Y'?'Yes':'No'}/> 

                                <Field component={CusFormLabelRtl} 
                                     leftLabelId={'lblFATCAUSR'} leftLabelName={fatcaList[2].lblname} 
                                    id={'FATCAUSR'} name={response.CRSFATCA.FATCAUSR==='Y'?'Yes':'No'}/>

                                <Field component={CusFormLabelRtl} 
                                     leftLabelId={'lblFATCANUSP'} leftLabelName={fatcaList[3].lblname} 
                                    id={'FATCANUSP'} name={response.CRSFATCA.FATCANUSP==='Y'?'Yes':'No'}/>
                                </FieldWrapper></div>: 
                                <div>
                
                                <Field component={FormSubTitle} id={'st2TaxDetailsCRS'} name={taxDetailsData.formSubTitle.ST3} />
                                <FieldWrapper>
                                <Field component={CusFormLabelRtl} 
                                     leftLabelId={'lblIsActiveBizEntity'} leftLabelName={taxDetailsData.label.csr} 
                                    id={'IsActiveBizEntity'} name={response.CRSFATCA.IsActiveBizEntity !==null? response.CRSFATCA.IsActiveBizEntity==='Y'?'Yes':'No':'Yes'}/> 
                                <Field component={CusFormLabelRtl} 
                                     leftLabelId={'lblCRSStatus'} leftLabelName={taxDetailsData.label.csrStatus} 
                                    id={'CRSStatus'} 
                                    name={getCRSStatusString()} /> 
                                </FieldWrapper>

                                <Field component={FormSubTitle} id={'st2TaxDetailsFATCA'} name={taxDetailsData.formSubTitle.ST2} />
                                <FieldWrapper>

                                <Field component={CusFormLabelRtl} 
                                     leftLabelId={'lblFATCABIZ'} leftLabelName={taxDetailsData.label.fatcaStatus} 
                                    id={'FATCABIZ'} 
                                    name={getFATCABIZString()}/> 

                                <Field component={CusFormLabelRtl} 
                                     leftLabelId={'lblFATCAUS'} leftLabelName={taxDetailsData.label.fatca} 
                                    id={'FATCAUS'} name={response.CRSFATCA.FATCAUS ==='Y'?'Yes':'No'}/> 
                            
                                </FieldWrapper>

                                </div>}
                                
                                <Field component={FormSubTitle} id={'st2TaxDetails'} name={taxDetailsData.formSubTitle.ST4} />
                                <Field component={CusFormLabelRtl} 
                                     leftLabelId={'lblTaxClare'} leftLabelName={isSoleProps()?taxDetailsData.termsSole:taxDetailsData.terms} 
                                    id={'TaxClare'} name={isSoleProps()?taxDetailsData.termsAgreeSole:taxDetailsData.termsAgree}/>

                            </fieldset>
                            </FormContainer>

                            <FormContainer>
                            <fieldset>
                                <Field component={CusFormTitle} id={'UploadDetails'} name={previewData.formContainerTitle.T12.name} 
                                        showEdit={false} onEdit={handleOnEdit} /> 

                                <div className="row" style={{borderBottom:'2px solid #FFC83D',paddingTop:'10px'}} />
 
                                <FieldWrapper>
                                {!isSoleProps() && (
                                <Field component={CusFormLabelRtl} 
                                     leftLabelId={'lblIssCapAmt'} leftLabelName={'Issued Capital Amount (Ordinary Shares)'} 
                                    id={'IssuedCapitalAmount'} name={response.CompDtls.IssuedCapitalAmount !== "null"? response.CompDtls.IssuedCapitalAmount:'Not applicable'}/>
                                )}
                                
                                <Field component={CusFormLabelRtl} 
                                     leftLabelId={'lblBizFormerName'} leftLabelName={'Business Former Name'} 
                                    id={'BizFormerName'} name={response.CompDtls.FormerName !==null?response.CompDtls.FormerName:'Not applicable' }/>
                                </FieldWrapper>
                                </fieldset>
                            </FormContainer>

                            <FormContainer>
                            <fieldset>
                                <Field component={CusFormTitle} id={'UploadDetails'} name={previewData.formContainerTitle.T13.name} 
                                    showEdit={showUploadDtlsEdit()} onEdit={handleOnEdit} /> 
                               
                                <div className="row" style={{borderBottom:'2px solid #FFC83D',paddingTop:'10px'}} />
                                {response.DocSubmit.AdoptAcraTemplate === null && docSignatureArray.length === 0 && docMemorandumArray.length === 0 && docLLPArray.length === 0 && docACSArray.length === 0?
                                <FieldWrapper>
                                    <Field component={CusFormLabelRtl}  
                                        leftLabelId={'lblNA'} leftLabelName={'Not applicable'} 
                                        id={'idDocNA'} name={''}/>
                                </FieldWrapper>:
                                <FieldWrapper>
                                {isSoleProps()?
                                <Field component={CusFormLabelRtl} 
                                    leftLabelId={'lblDoc'} leftLabelName={'An image of your signature'} 
                                    id={'Doc'} name={getSoleDocName()}/> 
                                    : 
                                    <div>
                                   <div>
                                   {docSignatureArray.map((item,idx)=> (
                                        <Field component={CusFormLabelRtl} key={idx} 
                                            leftLabelId={'lblDocSign'} leftLabelName={getSignatureNameLabel(item)} 
                                            id={'Doc'} name={item.File.name}/>
                                    ))}
                                  
                                    {response.DocSubmit.AdoptAcraTemplate !== null &&
                                    <Field component={CusFormLabelRtl} 
                                        leftLabelId={'lblDocYN'} leftLabelName={'Your company adopts the Standard ACRA template constitution'} 
                                        id={'Doc'} name={response.DocSubmit.AdoptAcraTemplate !== null? response.DocSubmit.AdoptAcraTemplate === 'N'?'No':'Yes':'Yes'} />}
                                        
                                
                                    {docMemorandumArray.map((item,idx)=> (
                                        <Field component={CusFormLabelRtl} key={idx} 
                                            leftLabelId={'lblDocMemo'} leftLabelName={'Certified true copies of Memorandum & Articles of Association (M&A)/ By-Laws/ Constitution'} 
                                            id={'Memo'} name={item.File.name}/>
                                    ))}
                              
                              
                                    {docLLPArray.map((item,idx)=> (
                                        <Field component={CusFormLabelRtl} key={idx} 
                                            leftLabelId={'lblDocLLP'} leftLabelName={'Limited Liability Partnership (LLP) Agreement'} 
                                            id={'LLP'} name={item.File.name}/>
                                    ))}

                                    {docACSArray.map((item,idx)=> (
                                        <Field component={CusFormLabelRtl} key={idx} 
                                            leftLabelId={'lblDocACS'} leftLabelName={'Certified true copy of Minutes of meeting reflecting list of office bearers'} 
                                            id={'ACS'} name={item.File.name}/>
                                    ))}
                                   </div>
                                </div>
                                }

                                {showUploadDeclaration() && (
                                <Field component={CusFormLabelRtl} 
                                     leftLabelId={'lblDoc'} leftLabelName={'I/We hereby certify the documents uploaded as true copy.'} 
                                    id={'Doc'} name={'I/We agree'}/>
                                )}
                                </FieldWrapper> }
                                </fieldset>
                            </FormContainer>
                            {showNonAuthPerson() &&
                            <FormContainer>
                            <fieldset>
                                <Field component={CusFormTitle} id={'NonAuthPersonDetails'} name={'First Person’s contact details'} 
                                    showEdit={showEditTitle()} onEdit={handleOnEdit} /> 
                                <div className="row" style={{borderBottom:'2px solid #FFC83D',paddingTop:'10px'}} />
                                <FieldWrapper>
                                <Field component={CusFormLabelRtl} 
                                    leftLabelId={'lblName'} leftLabelName={appDetailsData.label.n} 
                                    id={'Name'} name={appDtls0.Name !== null? appDtls0.Name:''} />

                                <Field component={CusFormLabelRtl} 
                                    leftLabelId={'lblCnOfDomMobileNoCode'} leftLabelName={appDetailsData.label.cc} 
                                    id={'MobileNoCode'} name={'+65 Singapore'} />

                                <Field component={CusFormLabelRtl} 
                                    leftLabelId={'lblMobileNo'} leftLabelName={appDetailsData.label.mno} 
                                    id={'MobileNo'} name={appDtls0.MobileNo !== null? appDtls0.MobileNo:''} />
    
                                <Field component={CusFormLabelRtl} 
                                    leftLabelId={'lblEmailAdd'} leftLabelName={appDetailsData.label.em} 
                                    id={'EmailAdd'} name={appDtls0.EmailAdd !== null?appDtls0.EmailAdd:''} />
                                </FieldWrapper> 
                            </fieldset>
                            </FormContainer>}

                            <FormContainer>
                            <fieldset>
                                <Field component={CusFormTitle} id={'AcctOpeningMY'} name={'Opening of Business Account in Malaysia'} 
                                    showEdit={showEditTitle()} onEdit={handleOnEdit} /> 
                                <div className="row" style={{borderBottom:'2px solid #FFC83D',paddingTop:'10px'}} />
                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">     
                                        <div style={{float:'left',width:'5%',paddingTop:'3%'}}>
                                            {response.MalaysiaBizAcct.needMYBizAcctSetup === 'true'?
                                            <span className="k-icon k-i-check" />
                                            :
                                            <span className="k-icon k-i-close" />
                                            }
                                        </div>
                                        <label style={{float:'left',width:'95%',paddingTop:'3%',paddingRight:'3%'}}>
                                     
                                             Yes, I have business dealings in Malaysia and I would like to set up a Business Account with Maybank <b><i>Malaysia</i></b>.
                                             
                                        </label>   
                                     </div>
                                </div>
                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">     
                                        <div style={{float:'left',width:'5%'}}>
                                            {response.MalaysiaBizAcct.needMYBizAcctSetup === 'true'?
                                            <span className="k-icon k-i-close" />
                                            :
                                            <span className="k-icon k-i-check" />
                                            }
                                        </div>
                                        <label style={{float:'left',width:'95%',paddingRight:'3%'}}>
                                        No, I do not have any business dealings in Malaysia and I do not need a <b><i>Malaysia</i></b> Business Account.
                                        </label>   
                                    </div>
                                </div>
                                <div className="row around-xs inputPair elementVisible">
                                    <label className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <i>Note:I/We agree that my/our online application of Maybank Malaysia Business Account is subject to Maybank's approval; and Maybank will only contact me/us upon approval of our Maybank Singapore CASA online application.</i>
                                    </label>
                                </div>
                                <br/>
                            </fieldset>
        
                            </FormContainer>
                             
                            <FieldWrapper className="scroll-space"><br/><br/><br/><br/></FieldWrapper>
                             
                        {enableOTP? 
                          <FieldWrapper>
                            {(!showOTPBar?
                            <div className="row around-xs elementVisible yellow-bottom-bar">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <div style={{ paddingTop:'15px'}}>
                                        <button className="btn btn-success" onClick={handleShowOTP}>{'SUBMIT'}</button>
                                    </div>
                                    <div style={{ padding:'10px'}}>
                                        <a  className="txtBlue fbaPSize" onClick={handleSaveContinue}> {'Save and continue later'}</a>
                                    </div>
                                </div>
                            </div>:
                            <div>
                                {!isOtpGeneratedSuccess?
                                <div className="row around-xs elementVisible yellow-bottom-bar">
                                <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                                    <div className="box"></div>
                                </div>
                                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                                    <div className="box row" >
                                        <div className="otp-info-txt" style={{padding:'5px'}}>SMS OTP: Get the 6-digit OTP via SMS to authorize your transaction.</div>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                                    <div className="box row">
                                        <div className="otp-input">
                                            <input className="k-textbox" style={{ width: "100%" }} type="password" pattern="[0-9]+" maxLength="6" minLength="6" value={OTPValue}
                                                onKeyPress={isNumber} placeholder="SMS OTP" name="" id="OTPValue" disabled={!isOtpGeneratedSuccess} onChange={handleOTPInput} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                                    <div className="box row">
                                        <div className="otp-btn" >
                                            <button className="btn btn-success" onClick={handleRequestOTP}>{'REQUEST'}</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-1 col-md-1 col-lg-1">
                                    <div className="box"></div>
                                </div>
                           
                                </div>
                                :
                                <div className="row around-xs elementVisible yellow-bottom-bar">
                                    <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                                        {showOTPResendRequestErr? 
                                        <div className="box otp-sent-txt">
                                            <span className="k-icon k-i-warning" style={{paddingLeft:'10px', fontSize:'24px'}} />&nbsp; 
                                            OTP request unsuccessful
                                        </div>
                                        :
                                        <div className="box otp-sent-txt">
                                            <span className="k-icon k-i-check-outline" style={{paddingLeft:'10px', fontSize:'24px'}} />&nbsp; 
                                            OTP has been sent 
                                        </div>
                                        }
                                    </div>
                     
                                    <div className="col-xs-12 col-sm-5 col-md-5 col-lg-5">
                                        <div className="box row">
                                            <div className="otp-timer-txt">
                                                {showOTPResendRequestErr?
                                                <div style={{padding:'5px'}}>
                                                    {otpDisplayMsg()}
                                                    <br/>
                                                    <span style={{fontWeight:'bold'}} onClick={handleResendOTP}> 
                                                        {timeLeft === 0?
                                                        "Resend OTP"
                                                        :
                                                        "Resend in "+toHHMMSS(timeLeft)
                                                        }
                                                    </span>
                                                </div>
                                                :
                                                <div style={{padding:'5px'}}>
                                                    {otpDisplayMsg()}
                                                    <span style={{fontWeight:'bold'}} onClick={handleResendOTP}>&nbsp;click here</span>
                                                </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                            
                                    <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                                        <div className="box row">

                                        {/* <Tooltip anchorElement="target" position="top">
                                            <span className="k-icon k-i-clock otp-click-icon">
                                                {"Resend in "+toHHMMSS(timeLeft)} 
                                            </span> 
                                        </Tooltip> */}
                                          <span className="k-icon k-i-clock otp-click-icon" /> 
                                            
                                            <div className="otp-timer-input">
                                                <input className="k-textbox" style={{ width: "100%" }} type="password" pattern="[0-9]+" maxLength="6" minLength="6" value={OTPValue}
                                                onKeyPress={isNumber} placeholder="SMS OTP" name="" id="OTPValue" disabled={!isOtpGeneratedSuccess} onChange={handleOTPInput} />
                                            </div>
                                        </div>
                                    </div>
                                <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                                    <div className="box row">
                                        <div className="otp-btn">
                                            <button className="k-button btn btn-success" disabled={disableSubmitOTPBtn()} onClick={handleSubmit}>{'SUBMIT'}</button>
                                        </div>
                                    </div>
                                </div>
                        
                                </div>
                                }
                            </div> )}
                        </FieldWrapper>
                        :
                        <FieldWrapper>
                        {(!showOTPBar?
                            <div className="row around-xs elementVisible yellow-bottom-bar">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <div style={{ paddingTop:'15px'}}>
                                        <button className="btn btn-success" onClick={handleShowOTP}>{'SUBMIT'}</button>
                                    </div>
                                    <div style={{ padding:'15px'}}>
                                        <a  className="txtBlue fbaPSize" onClick={handleSaveContinue}> {'Save and continue later'}</a>
                                    </div>
                                </div>
                            </div>:
                            <div className="row around-xs elementVisible yellow-bottom-bar">
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6" style={{paddingTop:'15px'}}>
                                    <div style={{width:'50%',textAlign:'center',fontWeight:'500',float:'left'}}>
                                        <p>Type your 6-digit<br></br>SMS OTP</p>
                                    </div>    
                                    <div style={{width:'50%',float:'left'}}>
                                        <p>Please input your SMS One-Time Password<br></br>3 wrong PIN entries will invalidate this application</p>
                                    </div>                   
                                    </div> 
                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6" style={{paddingTop:'12px'}}>
                                        <div style={{width:'10%',float:'left'}} >
                                                <span className="k-icon k-i-clock" 
                                                    style={{ marginTop: "8px", fontSize:'24px'}}>
                                                </span>
                                          
                                        </div>
                                    <div style={{width:'40%',textAlign:'center',float:'left'}}>
                                        <Input type="password" pattern="[0-9]+" maxLength="6" minLength="6" value={OTPValue}
                                            placeholder="123456" name="" id="OTPValue" className="k-textbox" onChange={handleOTPInput} />
                                    </div>
                                    <div style={{float:'left',paddingLeft:'20px',paddingTop:'5px'}}>
                                        <button className="btn btn-success"  onClick={handleSubmit}>{'SUBMIT'}</button>
                                    </div>
                                </div>
                            </div>  )}
                        </FieldWrapper> }

                        <CusToast className="popUpBox" trigger={isError} setTrigger={setIsError} label={errMsg} timer={timer} /> 
                        </FormElement>
                    )} >       
             </Form>
             {isOtpLoading && (
                <Loading /> 
                )}
        </div>
    )
}

export default Preview;